import { z } from "zod";

export const hubspotUserSchema = z.object({
  userId: z.number(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
});
export type HubSpotUser = z.infer<typeof hubspotUserSchema>;
